exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".registration-nav>button:first-child{margin-right:2%}.datepicker,.vue-tel-input{height:35px!important}.datepicker .control.has-icons-left .icon{top:-1px;left:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0feba0ae","scoped":false,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/login/SignUpForm.vue
// module id = GPoM
// module chunks = 0 1